import type { components } from '@social-studio/operator-client';
import { useQuery } from '@tanstack/react-query';
import { api, call } from '../../lib/api';

export type TenantProblems = components['schemas']['TenantProblemsDto'];
export type TenantProblem = components['schemas']['TenantProblemDto'];

/** Tenants with something to look at, most errors first (REQ-140-015). */
export function useProblems() {
  return useQuery({ queryKey: ['operator-problems'], queryFn: () => call(() => api.GET('/v1/operator/problems')) });
}
